<template>
  <div>

    <div class="col-md-12" v-show="team == ''" style="margin-top:29vh; margin-bottom:30vh">
      <div class="loader_page"></div>
    </div>
    <div class="row" v-show="team != ''">
      <div class="col-md-12">
        <h3> <a @click="$router.go(-1)">
              <span class="ti ti-arrow-left" style="font-size:20px;position: inherit,margin-top:7px; margin-right: 10px"></span>
            </a>
           <s style="text-decoration:none">{{team.team.name}}</s></h3>
      </div>
      <div class="col-md-6">
        <div class="row">

          <div class="col-md-12 " style="padding-bottom:15px">
            <div v-if="team.team.img != undefined" class="row">
              <clazy-load :src="getLink(team.team.img)" class="card-img-top" style="text-align:center">
                <img :src="getLink(team.team.img)" class="card-img-top" style="padding-left:15px;padding-right:15px">
                <div class="preloader" slot="placeholder" style="padding-left:50%">
                  <img src="../assets/missingImage.png" />
                </div>
              </clazy-load>
            </div>
          </div>

        </div>
        <div class="row">

          <div class="col-md-6">
            <div class="row label-zl">
              <div class="start">
                <img src="../assets/label.png" class>
              </div>
              <div class="md10">
                <h5>Osoby</h5>
              </div>
              <div class="end">
                <img src="../assets/end.png" class>
              </div>
            </div>
            <div class="card mb-2">
              <div class="card-body">
                <div v-show="team.team.icon != undefined" class="row" style=" overflow-y:auto">

                  <div class="col-md-12">
                    <ol start="1">
                      <li v-for="(item, index) in team.team.members" :key="index">
                        <p v-if="item.fname != undefined">{{item.fname}} {{item.lname}}-{{item.pos}}</p>
                        <p v-if="item.name != undefined">{{item.name}}</p>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6 ">
            <div class="row label-zl">
              <div class="start">
                <img src="../assets/label.png" class>
              </div>
              <div class="md10">
                <h5>Samochód:</h5>
              </div>
              <div class="end">
                <img src="../assets/end.png" class>
              </div>
            </div>
            <div class="card mb-2">
              <div class="card-body">
                <div v-show="team.team.icon != undefined" class="row" style=" overflow-y:auto">
                  <div class="col-md-12">
                    <div>Wybrany: {{team.vehicle.mark}} {{team.vehicle.model}} {{team.vehicle.details}}</div>
                    <div>Numer startowy: {{team.number}}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
      <div class="col-md-6">
        <div class="row label-zl">
          <div class="start">
            <img src="../assets/label.png" class>
          </div>
          <div class="md9">
            <h5>Aktualna pozycja</h5>
          </div>
          <div class="end-text">
            <span v-if="pos != ''" style="float:right; color: rgb(204, 204, 204); font-size: 11px; font-weight: 400;padding-top:15px" v-b-tooltip.hover :title="gps.updatedAt | formatDate">
              Aktualizacja: {{gps.updatedAt | ago}}</span>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">

            <div v-if="pos == ''" style="text-align:center;padding-top:106px;padding-bottom:107px">
              
              <h4 style="padding-top:20px">Nie podaliśmy jeszcze, gdzie jesteśmy :)</h4>
            </div>
            <GmapMap v-if="pos != ''" :center="pos" :zoom="14" map-type-id="terrain" style="width: 100%; height: 400px">
              <GmapMarker :position="pos" :clickable="true" :draggable="false" :icon="url + team.team.icon" />
            </GmapMap>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="team != ''">
      <div class="col-md-6">
        <div class="row label-zl">
          <div class="start">
            <img src="../assets/label.png" class>
          </div>
          <div class="md10">
            <h5>Lista postów</h5>
          </div>
          <div class="end">
            <img src="../assets/end.png" class>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">

            <div class="inbox_chat" v-show="posts.length != 0">
              <div class="chat_list " v-for="(item, index) in posts" :key="index">
                <div class="chat_people">
                  <div class="chat_img">
                    <img :src="url + item.owner.icon" alt="sunil">
                  </div>
                  <div class="chat_ib">
                    <h5>
                      {{item.owner.name}}
                      <span class="chat_date" v-b-tooltip.hover :title="item.updateAt | formatDate">{{item.updatedAt | ago}}</span></h5>
                    <p>{{item.text}}</p>
                    <div class="row">

                      <clazy-load :src="medialink + item + '.m.jpg'" class="card-img-top col-md-2 col-xs-3" v-for="(item,index) in item.media" :key="index">
                        <img :src="medialink + item + '.m.jpg'" class="card-img-top" style="max-width:100%;border-radius:0;" @click="show('gallery', medialink + item + '.jpg')">
                        <div class="preloader" slot="placeholder">
                          <img src="../assets/missingImage.png" />
                        </div>
                      </clazy-load>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div v-show="posts.length == 0" class="col-md-12" style="text-align:center;">
              
              <h4 style="padding-top:20px">Na razie pusto na naszym blogu, ale niebawem coś napiszemy!</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row label-zl">
          <div class="start">
            <img src="../assets/label.png" class>
          </div>
          <div class="md10">
            <h5>Awarie</h5>
          </div>
          <div class="end">
            <img src="../assets/end.png" class>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">

            <div class="inbox_chat" v-show="issues.length != 0">
              <div class="chat_list " v-for="(item,index) in issues" :key="index" v-on:click="viewComments(item)">
                <div class="chat_people">
                  <div class="chat_img"> <img :src="url + item.team.avatar" alt="sunil"> </div>
                  <div class="chat_ib">
                    <h5>{{item.team.name}} <span class="chat_date" v-b-tooltip.hover :title="item.createdAt | formatDate">{{item.createdAt | ago}}</span></h5>
                    <p>{{item.text}}</p>
                  </div>
                </div>
              </div>

            </div>
            <div v-show="issues.length == 0" class="col-md-12" style="text-align:center;">
              
              <h4 style="padding-top:20px">Niech trytytki i taśma będą z nami. Póki co brak awarii :)</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="team != ''" style="margin-top:20px">
      <div class="col-md-12">
        <div class="row label-zl">
          <div class="start">
            <img src="../assets/label.png" class>
          </div>
          <div class="md10">
            <h5>Galeria</h5>
          </div>
          <div class="end">
            <img src="../assets/end.png" class>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">

            <div class="row" style="height:300px;overflow-y:auto">
              <div class="col-md-3 col-xs-3" v-for="(item, index) in media" :key="index" style="padding-left:0px;padding-right:0px;">
                <clazy-load :src="medialink + item.image + '.m.jpg'" class="card-img-top">
                  <img :src="medialink + item.image + '.m.jpg'" class="card-img-top" style="height:200px;border-top-left-radius:0px;border-top-right-radius:0px" @click="show('gallery', medialink + item.image + '.jpg')">
                  <div class="preloader" slot="placeholder">
                    <div class="loader gal"></div>
                  </div>
                </clazy-load>
              </div>
              <div class="col-md-12" v-show="media.length == 0" style="text-align:center;padding-top:40px;padding-bottom:40px">
                
                <h4 style="padding-top:20px"></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="comments">
      <div class="col-md-12" v-show="info.comments.length == 0 || info.comments == 0" style="text-align:center;padding-top:40px;padding-bottom:40px">
        
        <h4 style="padding-top:20px">Brak dostępnych komentarzy!</h4>
      </div>
      <div class="inbox_chat" v-show="info.comments.length != 0">
        <div class="chat_list " v-for="(item,index) in info.comments" :key="index">
          <div class="chat_people">

            <div class="chat_img"> <img :src="url + info.team.avatar" alt="sunil"> </div>
            <div class="chat_ib">
              <h5>{{item.team.name}} <span class="chat_date" v-b-tooltip.hover :title="item.date | formatDate">{{item.date | ago}}</span></h5>
              <p>{{item.text}}</p>
            </div>
          </div>
        </div>
      </div>

    </modal>
    <modal name="gallery" :scrollable="true" :adaptive="true" :height="'auto'">
      <img :src="gal" alt="">
    </modal>
  </div>
</template>

<script>
  import api from '../http/api.js'
  import config from '../config.json'

  export default {
    data() {
      return {
        team: {
          team: {
            name: "Brak"
          },
          vehicle: {
            mark: "Brak"
          }
        },
        posts: [],
        issues: [],
        media: [],
        medialink: config.media,
        url: config.media,
        gal: {},
        gps: {
          createdAt: 0,
          updatedAt: 0
        },
        info: {
          comments: []
        },
        image: "../assets/alert.svg",
        pos: ""
      }
    },
    methods: {
      show(el, data) {
        this.gal = data
        switch (el) {
          case 'gallery':
            this.$modal.show('gallery');
            break;
        }
      },
      hide(el) {
        switch (el) {
          case 'gallery':
            this.$modal.hide('gallery');
            break;

        }
      },
      viewComments(item) {
        this.info = item
        this.$modal.show('comments');
      },
      getLink(data) {

        if (data.toLowerCase().match('http')) {
          return data;
        } else {
          return this.medialink + data + ".jpg";
        }
      },
      getTeam() {
        var vm = this
        api.getTeamAction(this.$route.params.id)
          .then(function(res) {
            if (res.data[0].team.gps != undefined)
              if (res.data[0].team.gps.coordinates.length != 0) {
                vm.pos = {
                  lng: res.data[0].team.gps.coordinates[0],
                  lat: res.data[0].team.gps.coordinates[1]
                }
                vm.gps = {
                  updatedAt: res.data[0].metadata.gps.updatedAt || res.data[0].udaptedAt
                }
              }
            vm.team = res.data[0];
          })
      },

      getGPS() {
        var vm = this
        api.getTeamGPS(this.$route.params.id)
          .then(function(res) {
            var data = res.data[0];
            if (data.gps.coordinates.length != 0) {
              vm.pos = {
                lng: data.gps.coordinates[0],
                lat: data.gps.coordinates[1]
              }

              vm.gps = {
                createdAt: data.createdAt,
                updatedAt: data.metadata.gps.updatedAt || data.udaptedAt
              }
            }

          });
      },

      getPost() {
        var vm = this
        api.getTeamAction(this.$route.params.id, 'posts')
          .then(function(res) {
            vm.posts = res.data
          })
      },
      getIssues() {
        var vm = this
        api.getTeamAction(this.$route.params.id, 'issues')
          .then(function(res) {
            vm.issues = res.data
          })
      },
      getMedia() {
        var vm = this
        api.getTeamAction(this.$route.params.id, 'media')
          .then(function(res) {
            vm.media = res.data
          })
      }
    },
    created() {
      this.getTeam()
      this.getGPS()
      this.getPost()
      this.getIssues()
      this.getMedia()
    }
  }
</script>

<style lang="css">
  .nopadding {
    padding: 0;
  }

  .gal {
    margin-top: 80px;
    margin-bottom: 30px;
    margin-left: 120px
  }
</style>
